import {Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild} from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { debounceTime, map, switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {BrowseConfig} from "@core/bean/browse-config";
import {BrowseService} from "@shared/components/browse/browse.service";
export const EXE_COUNTER_VALUE_ACCESSOR:any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SearchBrowseComponent),
  multi: true
};
@Component({
  selector: 'app-search-browse',
  templateUrl: './search-browse.component.html',
  styles: [],
  providers: [EXE_COUNTER_VALUE_ACCESSOR]
})
export class SearchBrowseComponent implements OnInit {
  searchChange$ = new BehaviorSubject('');
  optionList = [];
  isLoading = false;

  onSearch(value: string): void {
    this.isLoading = true;
    this.searchChange$.next(value);
  }

  constructor(private http: HttpClient,private browseService:BrowseService) {
  }

  ngOnInit(): void {
    // tslint:disable-next-line:no-any
    let baseUrl = `${this.randomUserUrl}?page=0&&size=5&`;
    if(this.selectSearchData){
      let that = this;
      Object.keys(this.selectSearchData).forEach(function (key) {
        if(that.selectSearchData[key] || that.selectSearchData[key] == '0') {
          baseUrl = baseUrl + `propertyNames=${key}&propertyValues=${that.selectSearchData[key]}&`
        }
      })
    }
    const getRandomNameList = (str: string) =>
      str?this.http.get(`${baseUrl}propertyNames=${this.fieldName}&propertyValues=${str}`).pipe(map((res: any) => res)).pipe(map((list: any) => {
        return list;
      })):this.http.get(`${baseUrl}`).pipe(map((res: any) => res)).pipe(map((list: any) => {
        return list;
      }));
    const optionList$: Observable<string[]> = this.searchChange$.asObservable().pipe(debounceTime(500)).pipe(switchMap(getRandomNameList));
    optionList$.subscribe(data => {
      this.optionList = data;
      this.isLoading = false;
    });
  }

  @Input() name:string;

  /**
   * 是否必填
   */
  @Input() required:boolean;
  /**
   * 是否禁用
   */
  @Input() disabled:boolean;

  //字段名
  @Input() fieldName;
  /**
   * 是否用公用的浏览按钮
   * */
  @Input() browseComponent;

  @Input() isCommons:boolean;
  /**
   * 业务参数
   * apiUrl：后端接口地址 例如：'api/company'
   *searchFormList：表单筛选条件，数组，例如[{label:'公司名称',value:'companyName'},{label:'公司代码',value:'companyCode'}]
   * tableFieldList：表格里面要展示的数据。数组，例如[{label:'公司代码',value:'companyCode'},{label:'公司名称',value:'companyName'}]
   *title:列表title
   * config：业务配置参数，{multiple:true,searchData:{}},multiple为是否多选，searchData：默认带的搜索条件
   * */
  @Input() commonsObj;
  /**
   *在select中搜索时传的url
   * */
  @Input() randomUserUrl:string;
  /**
   * 搜索条件
   * */
  @Input() selectSearchData:any;

  @Output() private selectData = new EventEmitter(); //选择数据时的回调
  @Output() private clear = new EventEmitter(); //清楚数据时的回调
  innerValue:any;
  propagateChange = (_:any) => {
  };
  writeValue(obj:any):void {
    this.innerValue = obj;
  }
  registerOnChange(fn:any):void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn:any):void {
  }
  changeVal(val) {
    this.propagateChange(val);
    if(val){
      for(let i=0;i<this.optionList.length;i++){
        if(val == this.optionList[i][this.fieldName]){
          this.selectData.emit(this.optionList[i]);
          break;
        }
      }
    }else{
      this.clear.emit();
    }
  }
  //  使用公用浏览按钮时
  @ViewChild('commonsBrowse') commonsBrowse;
  selectSupplier(){
    if(this.isCommons && this.commonsObj){
      if(this.commonsObj.config && this.commonsObj.config.multiple){
        this.commonsObj.config.multiple = false;
      }
      this.commonsBrowse.initData();
      return;
    }
    let browseConfig: BrowseConfig = new BrowseConfig(this.browseComponent);
    if(this.selectSearchData){
      browseConfig.searchData = this.selectSearchData;
    }
    console.log(this.browseComponent);
    this.browseService.open(browseConfig,
      (result) => {
        this.selectData.emit(result);
      },
      () => {
      });
  }

  //  选中数据回调
  chooseData(result){
    this.selectData.emit(result);
  }
}
